import { render, staticRenderFns } from "./BranchDetailByStatus.vue?vue&type=template&id=2ed60cc6"
import script from "./BranchDetailByStatus.vue?vue&type=script&lang=js"
export * from "./BranchDetailByStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports